export default {
    logoAltText: 'Logo',
    footerLineOne: '© 2020 by Healthcare Services Platform Consortium ',
    footerLineTwo: 'Terms of Use & Privacy Statement ',
    footerLineThree: 'Help',
    settingsLabel: 'Settings',
    signOutLabel: 'Sign Out',
    navigation: {
        ehrSimulator: 'EHR Simulator',
        apps: 'Apps',
        hooks: 'CDS Hooks',
        launchScenarios: 'Launch Scenarios',
        patients: 'Patients',
        practitioners: 'Practitioners',
        personas: 'Personas',
        profiles: 'Profiles',
        dataManager: 'Data Manager',
        tools: 'Tools',
        userManagement: 'Users',
        ehrIntegration: 'EHR Integration',
        documentation: 'Documentation',
        settings: 'Settings'
    },
    sandboxSelector: {
        mainLabel: 'Sandboxes',
        createLabel: '+ Create Sandbox'
    },
    defaultSandboxTitle: '',
    dashboard: 'Dashboard',
    signInLabel: 'Sign In'
}



// WEBPACK FOOTER //
// ./src/assets/strings/index.js